export default "__VITE_ASSET__DoP$yEVH__"